import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Modal, Input, notification } from "antd";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaEdit } from "react-icons/fa";
import { MdAdminPanelSettings, MdSubscriptions } from "react-icons/md";
import { Card, Button } from "antd";
import { PiDotsThreeBold, PiContactlessPaymentFill } from "react-icons/pi";
import { IoIosTime } from "react-icons/io";
import { FaCrown } from "react-icons/fa";
import RemainingDays from "../components/Charts/RemainingDays";
import TrancationTable from "../components/Leads/TrancationTable";
import { GoStack } from "react-icons/go";
import Avatar from "@mui/material/Avatar";
import { Link, useNavigate } from "react-router-dom";
import { FaMagnifyingGlassLocation } from "react-icons/fa6";
import { baseURL } from "../store/api/axios";
import { encryptdata } from "../utils/encryptDecrypt";
import { useMediaQuery } from "react-responsive";

const MyProfile = () => {
  const [profileData, setProfileData] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reload, setReload] = useState(false);
  const userID = localStorage.getItem("userId");
  const accessToken = localStorage.getItem("accessToken");
  const Domain = localStorage.getItem("domain");
  const [formData, setFormData] = useState({
    name: "",
    mobileNo: "",
    location: "",
  });

  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 576 });

  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    // Check if this is the first time the page is being loaded
    if (sessionStorage.getItem("hasVisitedProfile") !== "true") {
      // Set sessionStorage to mark that the user has visited the page
      sessionStorage.setItem("hasVisitedProfile", "true");
      // Trigger a page refresh
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }, []);

  const fetchMyProfile = async () => {
    try {
      // const encrypt = encryptdata({userID})
      const response = await fetch(`${baseURL}user/profile-business/${userID}`);
      if (!response.ok) {
        throw new Error("Failed to get user profile");
      }
      const responseData = await response.json();
      const businessProfile = responseData.businessprofile.businesses[0];
      localStorage.setItem("name", businessProfile.name);
      localStorage.setItem("mobileNo", businessProfile.mobileNo);
      localStorage.setItem("location", businessProfile.location);
      setProfileData(responseData.businessprofile);
    } catch (error) {
      setError(error.message);
      console.error("Error fetching profile:", error);
    }
  };

  const fetchSubscription = async () => {
    try {
      const encrypt = encryptdata({ userID });
      const response = await fetch(
        `${baseURL}masters/usersubscription/latestuserplan/${userID}`,
      );
      if (!response.ok) {
        throw new Error("Failed to get subscription plan");
      }
      const subResponse = await response.json();
      setSubscriptionData(subResponse.data);
      const planamount =
        subResponse.data.subscriptionplan?.Subscriptiondetails?.monthAmount ||
        0;
      const provinceId = subResponse.data.subscriptionplan?.provinceId || [];

      localStorage.setItem("provinceid", JSON.stringify(provinceId));
      localStorage.setItem("subscriptionamount", planamount);
    } catch (error) {
      setError(error.message);
      console.error("Error fetching subscription:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleOk = async () => {
    const encrypt = encryptdata({ userID });
    const apiUrl = `${baseURL}user/updateprofile/${userID}`;

    try {
      const encrypt = encryptdata(formData);
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(encrypt),
      });

      if (response.ok) {
        const result = await response.json();
        localStorage.setItem("name", formData.name);
        localStorage.setItem("mobileNo", formData.mobileNo);
        localStorage.setItem("location", formData.location);
        setFormData({
          name: formData.name,
          mobileNo: formData.mobileNo,
          location: formData.location,
        });
        notification.success({
          message: "Success",
          description: "Profile updated",
        });
        fetchMyProfile();
      } else {
        notification.error({
          message: "Opps",
          description: "Something went wrong, try later",
        });
      }
    } catch (error) {
      console.error("Error while updating profile:", error);
    }

    setIsModalOpen(false);
  };

  useEffect(() => {
    let name = localStorage.getItem("name") || "";
    let mobileNo = localStorage.getItem("mobileNo") || "";
    let location = localStorage.getItem("location") || "";

    fetchMyProfile();
    fetchSubscription();

    setFormData({ name, mobileNo, location });
  }, []);

  const availableAmount = profileData?.AvailableAmount || 0;
  const creditpoints = profileData?.OutofAmount || 0;
  // const creditpoints = subscriptionData?.subscriptionplan?.Subscriptiondetails?.creditpoints || 0;

  if (!profileData) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="loaderMain"></div>
      </div>
    );
  }

  // if (!subscriptionData || !subscriptionData.subscriptionplan.Subscriptiondetails) {
  //   return (
  //     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
  //     <div className="loaderMain"></div>
  //   </div>
  //   )
  // }
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  return (
    <div>
      <Row>
        <Col xs={12} md={4}>
          <div className="profile-card">
            <div className="profile-header">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "150px",
                  backgroundColor: "#8A9CFF",
                  borderRadius: "10px",
                }}
              >
                <Avatar
                  style={{
                    width: "100px",
                    height: "100px",
                    border: "3px solid #ffffff",
                    marginBottom: "10px",
                    borderRadius: "50%",
                  }}
                >
                  {" "}
                  {profileData.businesses?.[0]?.companyName
                    ?.charAt(0)
                    .toUpperCase()}{" "}
                </Avatar>
              </div>

              <button onClick={showModal} className="edit-button">
                <FaEdit />
              </button>
            </div>

            <h2 className="profile-name">
              {profileData.businesses?.[0]?.companyName || "No Company Name"}
            </h2>
            <p className="profile-birthday">
              {/* {Domain} */}
              {/* {new Date(
                profileData.businesses?.[0]?.startDate
              ).toLocaleDateString() || "N/A"} */}
            </p>
            <hr />

            <div className="profile-details">
              <p className="mb-3">
                <MdAdminPanelSettings size={20} className="icon" />{" "}
                {profileData.businesses?.[0]?.name || "No name"}
              </p>
              <p className="mb-3">
                <FaEnvelope className="icon" />{" "}
                {profileData.businesses?.[0]?.email || "No email"}
              </p>
              <p className="mb-3">
                <FaPhoneAlt className="icon" />
                {profileData.businesses?.[0]?.mobileNo || "No number"}
              </p>
              <p className="mb-3">
                <FaMapMarkerAlt className="icon" />{" "}
                {profileData.businesses?.[0]?.location || "No location"}
              </p>
            </div>
            <hr />
            <div className="profile-details">
              <p className="mb-3">
                <FaMagnifyingGlassLocation className="icon" />{" "}
                <strong>Preferred location:</strong>{" "}
                {/* {subscriptionData?.subscriptionplan?.Subscriptiondetails?.title || ""} */}
                {profileData.businesses?.[0]?.locationNames?.length > 0 ? (
                  <ul>
                    {profileData.businesses[0].locationNames.map(
                      (location, index) => (
                        <li key={index}>{location}</li>
                      ),
                    )}
                  </ul>
                ) : (
                  "No location"
                )}
              </p>
              <p className="mb-3">
                <IoIosTime className="icon" /> <strong>Credits allotted</strong>{" "}
                : {creditpoints}
              </p>
              <p className="mb-3">
                <PiContactlessPaymentFill className="icon" />{" "}
                <strong>Payment method</strong> : Net Banking
              </p>
            </div>
          </div>
        </Col>

        <Col xs={12} md={8} className="mt-3 mt-md-0">
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: isMobile ? "column" : "row",
                gap: "16px",
              }}
            >
              <Card
                title="Subscription"
                extra={
                  <PiDotsThreeBold size={20} style={{ cursor: "pointer" }} />
                }
                style={{ width: "100%" }}
              >
                <div className="premium-container">
                  <div className="premium-text">
                    <h5 className="premium-title">
                      <FaCrown className="crown-icon" />
                      {subscriptionData?.subscriptionplan?.Subscriptiondetails
                        ?.title === "Custom Subscription"
                        ? "Custom"
                        : subscriptionData?.subscriptionplan
                            ?.Subscriptiondetails?.title || "Custom"}
                    </h5>
                    <span className="monthly-plan">
                      {subscriptionData?.subscriptionplan?.Subscriptiondetails
                        ?.title || "N/A"}
                    </span>
                  </div>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={handleOpen}
                  >
                    Upgrade Plan
                  </Button>
                  <Modal
                    open={show}
                    onCancel={handleClose}
                    title="Upgrade Subscription"
                    centered
                    footer={[
                      <Button
                        key="upgrade"
                        type="primary"
                        onClick={() => navigate("/upgrade-plan")}
                      >
                        Continue Upgrade
                      </Button>,
                      <Button
                        key="update"
                        onClick={() => navigate("/subscription-profile-update")}
                      >
                        Update Profile First
                      </Button>,
                    ]}
                  >
                    Continue with upgrade plan or update your profile details
                    first?
                  </Modal>
                </div>
                <div className="mt-2">
                  <p className="mb-0">
                    Active on{" "}
                    {formatDate(
                      subscriptionData?.subscriptionplan?.subscriptionDate ||
                        "DD-MM-YYYY",
                    )}
                  </p>
                  <span style={{ color: "#747474", fontSize: "smaller" }}>
                    We will send you a notification upon credits expiry
                  </span>
                  <p className="mb-0 mt-3">
                    <GoStack /> {creditpoints} Credits allotted
                  </p>
                  <span style={{ color: "#747474", fontSize: "smaller" }}>
                    Extend your Pro package to 1,000+ leads
                  </span>
                </div>
              </Card>
              <Card
                title="Credits Remaining"
                extra={
                  <PiDotsThreeBold size={20} style={{ cursor: "pointer" }} />
                }
                style={{ width: "100%" }}
              >
                <RemainingDays
                  creditpoints={creditpoints}
                  availableAmount={availableAmount}
                />
              </Card>
            </div>
          </div>

          <div className="mt-3">
            <Card title="Subscription transaction history">
              <div
                style={{
                  overflowX: "auto",
                  width: "100%",
                }}
              >
                <div style={{ minWidth: "700px" }}>
                  <TrancationTable />
                </div>
              </div>
            </Card>
          </div>
        </Col>
        <Modal
          title="Edit profile"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <Input
            name="name"
            placeholder="Admin Name"
            value={formData.name}
            onChange={handleInputChange}
            style={{ marginTop: "15px" }}
          />
          <Input
            name="mobileNo"
            placeholder="Mobile Number"
            value={formData.mobileNo}
            onChange={handleInputChange}
            style={{ marginTop: "15px" }}
          />
          <Input
            name="location"
            placeholder="Location"
            value={formData.location}
            onChange={handleInputChange}
            style={{ marginTop: "15px" }}
          />
          <Row>
            <Col md={6}>
              <div className="mt-4">
                <p style={{ color: "#5e5e5e" }}> My Project Image </p>
                {profileData.businesses?.[0]?.projectPhoto ? (
                  <img
                    src={profileData.businesses[0].projectPhoto}
                    alt="Project Preview"
                    style={{
                      width: "100%",
                      maxWidth: "200px",
                      borderRadius: "10px",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <p style={{ color: "#888" }}>No image available</p>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div className="mt-4">
                <p style={{ color: "#5e5e5e" }}> My Brochure</p>
                {profileData.businesses?.[0]?.brochureCreatives?.length > 0 ? (
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
                  >
                    {profileData.businesses[0].brochureCreatives.map(
                      (pdfUrl, index) => (
                        <a
                          key={index}
                          href={pdfUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "inline-block",
                            padding: "10px 16px",
                            backgroundColor: "#f3f4f6",
                            borderRadius: "8px",
                            textDecoration: "none",
                            color: "#111827",
                            fontWeight: "500",
                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                          }}
                        >
                          📄 View Brochure {index + 1}
                        </a>
                      ),
                    )}
                  </div>
                ) : (
                  <p style={{ color: "#888" }}>No brochures available</p>
                )}
              </div>
            </Col>
          </Row>
        </Modal>
      </Row>
    </div>
  );
};

export default MyProfile;

// import React, { useEffect, useState } from 'react'
// import {Row,Col} from 'react-bootstrap';
// import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaEdit } from "react-icons/fa";
// import { MdAdminPanelSettings,MdOutlinePeople,MdSubscriptions } from "react-icons/md";
// import {Card} from 'antd'
// import { PiDotsThreeBold,PiContactlessPaymentFill } from "react-icons/pi";
// import { IoIosTime } from "react-icons/io";
// import { FaCrown } from "react-icons/fa";
// import RemainingDays from "../components/Charts/RemainingDays";
// import {Button} from 'antd';
// import TrancationTable from '../components/Leads/TrancationTable';

// const MyProfile = () => {

//   const [profileData, setProfileData] = useState(null);
//   const [subscriptionData, setSubscriptionData] = useState(null)
//   const [error, setError] = useState(null)
//   const userID = localStorage.getItem('userId')

//   const fetchMyProfile = async ()=>{
//     try {
// const encrypt = encryptdata({userID})
//       const response = await fetch(`${baseURL}user/profile-business/${encrypt}`)
//       if(!response.ok){
//         throw new Error('Failed to get user profile')
//       }
//       const responseData = await response.json()
//       setProfileData(responseData.businessprofile)
//     } catch (error) {
//       setError(error.message)
//       console.error('Error fetching profile:', error);
//     }
//   }

//   const fetchSubscription = async ()=>{
//     try {
// const encrypt = encryptdata({userID})
//       const response = await fetch (`${baseURL}masters/usersubscription/latestuserplan/${encrypt}`)
//       if(!response.ok){
//         throw new Error('Failed to get user profile')
//       }
//       const subResponse = await response.json()
//       setSubscriptionData(subResponse.data)
//     } catch (error) {
//       setError(error.message)
//       console.error('Error fetching subscription:', error);
//     }
//   }

//   useEffect(()=>{
//     fetchMyProfile()
//     fetchSubscription()
//   },[])

//   const { AvailableAmount } = profileData || {};
//   const creditpoints = subscriptionData.subscriptionplan?.creditpoints || 0;

//   if (!profileData) {
//     return <p>Loading...</p>;
//   }

//   if (!subscriptionData || !subscriptionData.subscriptionplan) {
//     return <p>No subscription data available.</p>; // Handle cases where `subscriptionData` is missing or malformed
//   }

//   return (
//     <div>
//        <Row>
//         <Col md={4}>
//            <div>
//            <div className="profile-card">
//       <div className="profile-header">
//         <img src="https://www.gartner.com/pi/vendorimages/surveysparrow_1722245657042.png" alt="Profile" className="profile-image" />
//         <button className="edit-button">
//           <FaEdit />
//         </button>
//       </div>

//       <h2 className="profile-name">{profileData.businesses[0]?.companyName || 'No Company Name'}</h2>
//       <p className="profile-birthday">{new Date(profileData.businesses[0]?.startDate).toLocaleDateString() || 'N/A'}</p>
//       <hr/>

//     <div className="profile-details">
//         <p className='mb-3'>
//           <MdAdminPanelSettings size={20} className="icon" /> {profileData.businesses[0]?.name || 'No name'}
//         </p>
//         <p className='mb-3'>
//           <FaEnvelope className="icon" /> {profileData.businesses[0]?.email || 'No email'}
//         </p>
//         <p className='mb-3'>
//           <FaPhoneAlt className="icon" />{profileData.businesses[0]?.mobileNo || 'No number'}
//         </p>
//         <p className='mb-3'>
//           <FaMapMarkerAlt className="icon" /> {profileData.businesses[0]?.location || 'No location'}
//         </p>
//         </div>
//         <hr/>
//         <div className="profile-details">
//         <p className="mb-3">
//         <MdSubscriptions className="icon" /> <strong>Subscription</strong> :{' '}
//         {subscriptionData.subscriptionplan?.title || 'N/A'}
//       </p>
//       <p className="mb-3">
//         <IoIosTime className="icon" /> <strong>Credits allotted</strong> :{' '}
//         {creditpoints}
//       </p>
//         <p className='mb-3'>
//           <PiContactlessPaymentFill className="icon" /> <strong>Payment method</strong>  : Net Banking
//         </p>
//         </div>
//     </div>
//            </div>
//         </Col>

//         <Col md={8}>
//           <div>
//           <div style={{ display:'flex', justifyContent: 'center', gap:'16px' }}>
//          <Card title="Subscription" extra={<PiDotsThreeBold size={20} style={{cursor:'pointer'}}/>}
//           style={{ width: '100%', }}>
//             <div className="premium-container">
//               <div className="premium-text">
//                 <h5 className="premium-title">
//                   <FaCrown className="crown-icon" /> Premium
//                 </h5>
//                 <span className="monthly-plan">Monthly plan</span>
//               </div>
//               <Button color="primary" variant="outlined">Upgrade Plan</Button>
//             </div>
//             <div className='mt-2'>
//               <p className='mb-0'>Active until Dec, 12 2025</p>
//               <span style={{color:'#747474', fontSize:'smaller'}}>We will send you a notification upon subscription expiry</span>
//               <p className='mb-0 mt-3'>₹ 7,999 Per Month</p>
//               <span style={{color:'#747474', fontSize:'smaller'}}>Extend your Pro package to 1,000+ leads</span>
//             </div>
//           </Card>
//             <Card title="Days Remaining" extra={<PiDotsThreeBold size={20} style={{cursor:'pointer'}}/>}
//           style={{ width: '100%',  }}>
//             <RemainingDays  creditpoints={creditpoints} availableAmount={AvailableAmount}  />
//         </Card>
//             </div>
//           </div>

//           <div className='mt-3'>
//             <Card title="Subscription transaction history" >
//               <TrancationTable />
//             </Card>
//           </div>
//         </Col>
//        </Row>
//     </div>
//   )
// }

// export default MyProfile
